import React from 'react';
import './TableFilter.css';

const TableFilter = (props) => (
    <div className={`TableFilter ${props?.className || ''}`}>
        {props.children}
    </div>
);

export default TableFilter;
